import request from '@services/request';

export const getAllPermissions = () => {
  return request
    .get('/api/v1/corresponsal/permissions')
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};
